export default "__VITE_ASSET__BYhUHET0__"